import React from "react";

const DEFAULT_TIME = 900000;

// create countdown hook called useCountdown
// useCountdown takes in a number and a function as arguments
// call the function when the time is up
// return the time remaining
const useCountdown = (
    time: number,
    callback: () => void,
    overrideTime?: number,
) => {
    const hasCalledBack = React.useRef(false);

    const [timeRemaining, setTimeRemaining] = React.useState(
        Math.floor(time - Date.now() + (overrideTime ?? DEFAULT_TIME)) / 1000,
    );

    React.useEffect(() => {
        const timer = setTimeout(() => {
            const newTime =
                Math.floor(time - Date.now() + (overrideTime ?? DEFAULT_TIME)) /
                1000;
            setTimeRemaining(newTime);
            if (newTime <= 0 && !hasCalledBack.current) {
                hasCalledBack.current = true;
                clearTimeout(timer);
                callback();
            }
        }, 1_000);

        return () => {
            clearTimeout(timer);
        };
    }, [timeRemaining]);

    React.useEffect(() => {
        setTimeRemaining(
            Math.floor(time - Date.now() + (overrideTime ?? DEFAULT_TIME)) /
                1000,
        );
    }, [time]);

    const clampedTimeRemaining = Math.max(timeRemaining, 0);

    const minutes = Math.floor(clampedTimeRemaining / 60);
    const seconds = Math.floor(clampedTimeRemaining % 60);

    return `${minutes < 10 ? `0${minutes}` : minutes}:${
        seconds < 10 ? `0${seconds}` : seconds
    }`;
};

export default useCountdown;
